<template>
	<div class="home">
		<img
			alt="logo"
			class="big-logo"
			src="../assets/logo-big.png"
		>
		<h1>ЕйСі ДіСі Процессінг</h1>
		<p>ТОВ “ЕЙСІ ДІСІ ПРОЦЕССІНГ” - є процесинговим центром, що з 2020 року є частиною в платіжної інфраструктури України.</p>
		<p>Наша Компанія надає послуги процесингу, клірингу та виконує операційні, інформаційні та інші технологічні функції, пов’язані з наданням платіжних послуг, без залучення коштів за платіжними операціями на свій рахунок.</p>
		<div class="employee-wrapper">
			<h2>{{ $t('main.subTitle2') }}</h2>
			<div class="employee-item">
				<img
					src="../assets/user.png"
					alt="user"
				>
				<div class="employee-info">
					<div class="employee-fio">
						{{ $t('main.fio1') }}
					</div>
					<div class="employee-position">
						{{ $t('main.position1') }}
					</div>
				</div>
			</div>
			<div class="employee-item">
				<img
					src="../assets/user.png"
					alt="user"
				>
				<div class="employee-info">
					<div class="employee-fio">
						{{ $t('main.fio2') }}
					</div>
					<div class="employee-position">
						{{ $t('main.position2') }}
					</div>
				</div>
			</div>
			<!-- <div class="employee-item">
				<img
					src="../assets/user.png"
					alt="user"
				>
				<div class="employee-info">
					<div class="employee-fio">
						{{ $t('main.fio3') }}
					</div>
					<div class="employee-position">
						{{ $t('main.position3') }}
					</div>
				</div>
			</div> -->
			<div class="employee-item">
				<img
					src="../assets/user.png"
					alt="user"
				>
				<div class="employee-info">
					<div class="employee-fio">
						{{ $t('main.fio4') }}
					</div>
					<div class="employee-position">
						{{ $t('main.position4') }}
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
//@ is an alias to /src

	export default {
		name: 'Main',
		components: {
		}
		/*beforeCreate () {
			console.log('1', this.$i18n);
		}*/
	};
</script>
<style scoped lang="less">

	.employee-wrapper{
		margin-top: 40px;
	}
	.employee-item{
		display: flex;
		align-items: flex-start;
		margin-bottom: 20px;
		img{
			margin-right: 20px;
			opacity: 0.8;

		}
		.employee-fio{
			margin: 10px 0;
		}
		.employee-position{
			opacity: 0.7;
		}

	}

</style>
